import React from "react";
import "../componentsStyle.scss";
import {
  ClockCircleOutlined,
  StarFilled,
  FireOutlined,
} from "@ant-design/icons";
import { packages } from "../../constants/appConstats";
import { PrimaryButton } from "../PrimaryButton";
import {
  BikeSvg,
  LocSvg,
  PeopleSvg,
  WaterBottleSvg,
  WineGlassSvg,
  TransportationSvg,
} from "../../assets/svg";
import { scrollToSection } from "../../hooks/ScrollToSection";

export const TourBanner = ({ data, languageId }) => {
  const tourData = packages?.find((el) => el?.id === data?.id);
  return (
    <section className="tourBanner">
      {/* Left Side */}
      <div className="tourInfo">
        <span className="category">
          {tourData?.subCategory?.[languageId]?.label}
        </span>

        <h1 className="title">{tourData?.title?.[languageId]?.label}</h1>

        {/* Stats */}
        <div className="stats">
          <div className="statItem">
            <StarFilled />
            <span>4.9 Rating</span>
          </div>

          <div className="statItem">
            <ClockCircleOutlined />
            <span>{tourData?.duration}</span>
          </div>

          <div className="statItem">
            <FireOutlined />
            <span>Easy / Moderate</span>
          </div>
        </div>

        {/* Description */}
        <p className="description">
          {tourData?.description?.[languageId]?.label}
        </p>

        {/* Icons */}
        {tourData?.id === 2 && (
          <div className="icons">
            <div className="icon">
              <LocSvg width={32} height={32} />
              <span>Free Local Guide</span>
            </div>

            <div className="icon">
              <PeopleSvg width={32} height={32} />
              <span>Small Groups</span>
            </div>

            <div className="icon">
              <BikeSvg fill={"#000"} width={32} height={32} />
              <span>Free Quality Bikes</span>
            </div>

            <div className="icon">
              <WaterBottleSvg fill={"#000"} width={32} height={32} />
              <span>Water included</span>
            </div>
          </div>
        )}

        {tourData?.id === 3 && (
          <div className="icons">
            <div className="icon">
              <LocSvg width={32} height={32} />
              <span>Free Local Guide</span>
            </div>

            <div className="icon">
              <PeopleSvg width={32} height={32} />
              <span>Lunch Included</span>
            </div>

            <div className="icon">
              <TransportationSvg fill={"#000"} width={32} height={32} />
              <span>Free Transportation</span>
            </div>

            <div className="icon">
              <WineGlassSvg fill={"#000"} width={32} height={32} />
              <span>Wine included</span>
            </div>
          </div>
        )}

        {tourData?.id === 4 && (
          <div className="icons">
            <div className="icon">
              <LocSvg width={32} height={32} />
              <span>Free Local Guide</span>
            </div>

            <div className="icon">
              <TransportationSvg fill={"#000"} width={32} height={32} />
              <span>Free Transportation</span>
            </div>

            <div className="icon">
              <WineGlassSvg fill={"#000"} width={32} height={32} />
              <span>Wine included</span>
            </div>
          </div>
        )}

        {/* Bottom */}
        <div className="bottomSection">
          <div className="price">
            <span className="amount">{tourData?.price} </span>
            <span className="per"> / person</span>
          </div>

          <PrimaryButton
            type="primary"
            label={"Book Now"}
            onClick={() => scrollToSection("timeline")}
          />
        </div>
      </div>

      {/* Right Side */}
      <div className="tourImageWrapper">
        <img src={tourData.img} alt="Tour" className="tourImage" />
      </div>
    </section>
  );
};
